import { t } from 'i18next'
import * as yup from 'yup'

const emailRegEx = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
const passwordRegEx =
  /^(?=.*[A-Z]).{6,}$/

const linkRegEx =
  /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/

export const signInSchema = yup.object().shape({
  email: yup
    .string()
    .required('Email is required')
    .matches(emailRegEx, 'Invalid email format.'),
  password: yup
    .string()
    .required('Password is required')
    .min(6, 'Password must be at least 6 characters long')
    .matches(
      passwordRegEx,
      'Password should be strong and must contain at least one uppercase letter, one lowercase letter, one number, and one special character',
    ),
})

export const signUpSchema = yup.object().shape({
  email: yup
    .string()
    .required('Email is required')
    .matches(emailRegEx, 'Invalid email format.'),
  userName: yup
    .string()
    .matches(/^[a-zA-Z0-9]+$/, 'UserName can only contain letters and numbers')
    .min(6, 'UserName must be at least 6 characters long')
    .required('UserName is required'),
})

export const enterPassword = yup.object().shape({
  password: yup
    .string()
    .required('Password is required')
    .min(6, 'Password must be at least 6 characters long')
    .matches(
      passwordRegEx,
      'Password should be strong and must contain at least one uppercase letter, and minimum 6 characters',
    ),
})

export const resetPassword = yup.object().shape({
  email: yup
    .string()
    .required('Email is required')
    .matches(emailRegEx, 'Invalid email format.'),
})

export const updatePassword = yup.object().shape({
  password: yup
    .string()
    .required('Password is required')
    .min(6, 'Password must be at least 6 characters long')
    .matches(
      passwordRegEx,
      'Password should be strong and must contain at least one uppercase letter, one lowercase letter, one number, and one special character',
    ),
  passwordConfirmation: yup
    .string()
    .required('Password Confirmation is required')
    .min(6, 'Password Confirmation must be at least 6 characters long')
    .oneOf([yup.ref('password')], 'Passwords must match'),
})

export const urlValidation = yup.object({
  link: yup
    .string()
    .required(t('enterUrl'))
    .matches(linkRegEx, t('enterCorrectUrl')),
})

export const designValidation = yup.object({
  avatar: yup.mixed().required(),
  title: yup.string().required().max(30),
  bio: yup.string().required().max(300),
  themeId: yup.number().required(),
  fontId: yup.number().required(),
  color: yup.string().required(),
})

export const userAccountSchema = yup.object().shape({
  email: yup
    .string()
    .required('Email is required')
    .matches(emailRegEx, 'Invalid email format.'),
  username: yup
    .string()
    .matches(/^[a-zA-Z0-9]+$/, 'UserName can only contain letters and numbers')
    .min(6, 'UserName must be at least 6 characters long')
    .required('UserName is required'),
})

export const settingsSchema = yup.object().shape({
  metaTitle: yup.string().required().max(30),
  metaDescription: yup.string().required().max(300),
  showSensitive: yup.boolean(),
  sensitiveAge: yup.string(),
})
